import { createSlice } from "@reduxjs/toolkit";
import { resetStateThunk } from "redux/Thunks/Authentication";
import getAllNotifications, { getPoperNotifications } from "redux/Thunks/Notification";
import Constants from "utils/Constants";
import notificationRowData from "utils/Types/notificationDummyData";

const initialState = {
  notificationLoading: Constants.IDLE,
  allNotifications: [],
  poperNotifications: [],
  poperNotificationLoading: Constants.IDLE,
  notificationListingPagiantion: {
    totalRecords: 0,
    completed: [],
  },
};

export const SystemNotificationSlice = createSlice({
  name: "SystemNotification",
  initialState,
  reducers: {
    updateNotificationState(state, action) {
      const notificationId = action.payload;
      const index = state.allNotifications.findIndex(
        (notification) => notification[Constants.MONGOOSE_ID] === notificationId
      );
      if (index !== -1) {
        state.allNotifications[index].isRead = true;
      }

      // for poper notification
      const poperIndex = state.poperNotifications.findIndex(
        (notification) => notification[Constants.MONGOOSE_ID] === notificationId
      );
      if (poperIndex !== -1) {
        state.poperNotifications[poperIndex].isRead = true;
      }
    },

    markAllNotificationasRead(state) {
      state.allNotifications = state.allNotifications.map((notification) => ({
        ...notification,
        isRead: true,
      }));
      state.poperNotifications = state.poperNotifications.map((notification) => ({
        ...notification,
        isRead: true,
      }));
    },
  },

  extraReducers: {
    [getAllNotifications.pending]: (state) => {
      state.notificationLoading = Constants.PENDING;
    },
    [getAllNotifications.fulfilled]: (state, { payload, meta }) => {
      // state.notificationLoading = Constants.FULFILLED;
      // state.allNotifications = payload.data.data.notifications || [];
      state.loading = Constants.FULFILLED;
      // Destructure data for easier access
      const { notifications, totalCount } = payload.data.data;

      // Get pagination info from the meta argument
      const params = new URLSearchParams(meta.arg);
      const page = parseInt(params.get("page"), 10);
      const perPage = parseInt(params.get("perPage"), 10);

      // If list is empty, initialize it with the required format
      const notificationList =
        page === 0
          ? Array.from({ length: totalCount }, () => ({ ...notificationRowData }))
          : [...state.allNotifications]; // shallow copy to avoid direct state mutation
      // Calculate start index for pagination and replace elements in the array
      const startIndex = page * perPage;
      notificationList.splice(startIndex, perPage, ...notifications);

      // Update state with new data
      state.allNotifications = notificationList;
      state.notificationListingPagiantion.totalRecords = totalCount;
      state.notificationListingPagiantion.completed =
        page === 0 ? [page] : [...state.notificationListingPagiantion.completed, page];
    },
    [getAllNotifications.rejected]: (state) => {
      state.notificationLoading = Constants.REJECTED;
    },
    [getPoperNotifications.pending]: (state) => {
      state.poperNotificationLoading = Constants.PENDING;
    },
    [getPoperNotifications.fulfilled]: (state, { payload }) => {
      state.poperNotificationLoading = Constants.FULFILLED;
      state.poperNotifications = payload.data.data.notifications || [];
    },
    [getPoperNotifications.rejected]: (state) => {
      state.poperNotificationLoading = Constants.REJECTED;
    },
    [resetStateThunk.fulfilled]: (state) => {
      state.notificationLoading = Constants.IDLE;
      state.poperNotificationLoading = Constants.IDLE;
      state.allNotifications = [];
      state.poperNotifications = [];
      state.notificationListingPagiantion = {
        totalRecords: 0,
        completed: [],
      };
    },
  },
});

export const { updateNotificationState, markAllNotificationasRead } =
  SystemNotificationSlice.actions;
export default SystemNotificationSlice.reducer;
